import { Marketday } from '../marketday';
export class Energyflat {
    constructor(
        public id?: number,
        public marketdayNumber?: string,
        public validFrom?: any,
        public priceType?: string,
        public priceLow?: number,
        public priceNormal?: number,
        public priceSpecial?: number,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public marketday?: Marketday,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat.model.ts